import type { SignupFormValues } from '../types';
import { resumeEmailFromParams, type SignupSearch } from './signup-search';
import { stepFromSplat, type SignupStep } from './steps';

export type SignupRouteProps = {
  step: SignupStep;
  signupType: string | undefined;
  promoCode: string | undefined;
  initialFormValues: Partial<SignupFormValues> | undefined;
  resumeEmail: string | undefined;
};

/**
 * Resolve the URL into the funnel's entry props.
 *
 * Both URL-seeded inputs are scoped to the entry step, for different reasons.
 * The prefill: seeding `email` satisfies the funnel-integrity guard, so an
 * unconditional copy would make `/signup/company?email=x` deep-linkable. The
 * resume hand-off: step navigation preserves the search string verbatim, so
 * `?resume=true` is still in the URL after the hand-off advances — unscoped,
 * the provider would navigate again on arrival.
 *
 * `isGoogleSignup` resets on every entry-step arrival so navigating Back can't
 * carry a Google signup's skipped verification onto a different email.
 */
export function signupRouteProps(splat: string | undefined, search: SignupSearch): SignupRouteProps {
  const step = stepFromSplat(splat);
  const isEntryStep = step === 'index';

  return {
    step,
    signupType: search.signupType,
    promoCode: search.promoCode,
    initialFormValues: isEntryStep
      ? {
          email: search.email ?? '',
          firstName: search.first ?? '',
          lastName: search.last ?? '',
          isGoogleSignup: false,
        }
      : undefined,
    resumeEmail: isEntryStep ? (resumeEmailFromParams(search) ?? undefined) : undefined,
  };
}
